import type { ApiError } from "@entrilia/shared/api/types";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import { logError } from "@entrilia/shared/logging";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { TabularReport } from "../../../api/types/widgetTypes";
import NoDataResult from "../../common/NoDataResult";
import TabularReportListItemContent from "../../common/reports/mobile/TabularReportListItemContent";
import WidgetPreviewCardSkeleton from "./WidgetPreviewCardSkeleton";

interface Props {
  report: TabularReport | undefined;
  columnsLimit?: number;
  noDataText?: string;
  fetchError?: ApiError;
}

const WidgetPreviewCardContent = ({ report, columnsLimit, noDataText, fetchError }: Props) => {
  if (fetchError) {
    logError(fetchError, "[WidgetPreviewCardContent] fetchError");
    return <DataLoadingFailed />;
  }

  if (noDataText) {
    return <NoDataResult text={noDataText} />;
  }

  if (report === undefined) {
    return <WidgetPreviewCardSkeleton />;
  }

  if (report.rows.length === 0) {
    return <NoDataResult />;
  }

  return (
    <TabularReportListItemContent
      row={defined(report.rows[0])}
      columns={report.columns}
      columnsLimit={columnsLimit}
      detailColumns={report.detailColumns}
    />
  );
};

export default WidgetPreviewCardContent;
